<template>
  <div class="storeGoods">
    <van-nav-bar :title="title" fixed border>
      <template #left>
        <img src="../../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
      </template>
      <template #right>
	  	<van-icon name="apps-o" @click="showGoodCategoryList" :style="{'margin-right':'5px'}"/>
		<van-icon name="add-o" @click="goStoreGoodInfo()" />
      </template>
    </van-nav-bar>
    <div class="collapse">
    	<div class="empty" v-if="items.length==0&&filterParams.words==''&&!searchFocus&&!loading&&categoryActive==0">
			<span class="msg">暂无铺货</span>
			<van-button type="primary" block @click="goStoreGoodInfo()" style="margin-top:50px;">马上铺货</van-button>
		</div>
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-else>
			<form action="#">
				<van-search
				  v-model.trim="filterParams.words"
				  show-action
				  placeholder="请输入商品名称"
				  @focus="searchFocus=true"
				  @blur="searchFocus=false"
				  @search="onRefresh"
				>
					<template #action>
						<div @click="onRefresh">搜索</div>
						<van-icon name="filter-o" class="color_red" @click="showPickers(3)"/>
					</template>
				</van-search>
			</form>

			<van-tabs v-model="categoryActive">
				<van-tab title="所有上架"></van-tab>
				<van-tab :title="cate.c_name" v-for="(cate, i) in goodCategorys" :key="i"></van-tab>
				<van-tab title="已下架"></van-tab>
			</van-tabs>

			<van-list
			v-model="loading"
			:finished="finished"
			:finished-text="items.length==0?'暂无商品':'没有更多商品了'"
			@load="loadData"
			>
				<van-card
				  :num="item.g_stock"
				  :origin-price="item.g_price_origin>0?item.g_price_origin:null"
				  :price="item.g_price"
				  :desc="item.g_note"
				  :title="item.g_name"
				  :thumb="attach_url+item.g_img"
				  v-for="(item,index) in items"
				  :key="index"
				>
					<template #tags>
					</template>
					<template #footer v-if="item.delete_time==0">
						<van-button size="mini" type="primary" @click="goStoreGoodInfo(item.g_id)" :style="{'float':'left','margin-top':'10px'}">编辑</van-button>
						<van-button size="mini" type="danger" @click="offGoodInfo(item.g_id)" :style="{'float':'left','margin-top':'10px'}">下架</van-button>
						<van-button size="mini" type="info" @click="putShoppingCart(item)" :style="{'margin-top':'10px','padding':'0 5px'}">到店下单</van-button>
					</template>
				</van-card>
			</van-list>
		</van-pull-refresh>
    </div>

	<van-popup v-model="showGoodInfo" position="bottom" :style="{ 'max-height': '80%' }">
		<van-cell-group>
			<van-field
				v-model.trim="goodInfo.g_name"
				required
				maxlength="30"
				label="商品名称："
				placeholder="请输入商品名称"
				required
				clearable
			></van-field>
			<van-cell
				title="商品主图："
				required
				title-class="van-cell-title">
				<van-uploader max-count="1" v-model="imgList" :max-size="imgSizeLimit" @oversize="onOversize" :before-read="beforeRead" />
			</van-cell>
			<van-cell
				title="商品分类："
				is-link
				@click="showPickers(1)"
				:value="goodCategoryObj[goodInfo.c_id]"
				title-class="van-cell-title">
			</van-cell>

			<van-field v-model="goodInfo.g_price" type="number" label="售价：" required>
				<template #button>元</template>
			</van-field>
			<van-field v-model="goodInfo.g_price_origin" type="number" label="原价：">
				<template #button>元</template>
			</van-field>

			<van-field v-model="goodInfo.g_stock" type="digit" label="库存量：" required>
			</van-field>

			<van-cell
				title="售卖单位："
				required
				is-link
				@click="showPickers(2)"
				:value="goodUnitObj[goodInfo.g_unit]"
				title-class="van-cell-title">
			</van-cell>

			<van-field v-model="goodInfo.g_min_buy" type="digit" label="最低起售：" required>
			</van-field>

			<van-field v-model="goodInfo.g_day_limit" type="digit" label="每日限售：">
			</van-field>

			<van-field
			  v-model.trim="goodInfo.g_note"
			  rows="3"
			  autosize
			  label="商品简介："
			  type="textarea"
			  maxlength="3000"
			  placeholder="请输入简介内容..."
			  show-word-limit
			  required
			/>

			<van-cell
				title="商品图文："
				title-class="van-cell-title">
				<van-uploader max-count="1" v-model="imgNoteList" :max-size="imgSizeLimit" @oversize="onOversize" :before-read="beforeRead" />
			</van-cell>
			<van-field v-model="goodInfo.sorts" type="digit" label="排序：">
				<template #button>
					值大排前
				</template>
			</van-field>
		</van-cell-group>

		<van-divider>
			商品规格
			<van-icon name="add" @click="addGoodSku(-1)"  class="color_red" :style="{'margin-left':'10px'}"/>
		</van-divider>
		<van-cell-group>
			<van-cell
				:title="item.sku_name+'：'"
				title-class="van-cell-title"
				v-for="(item,ind) in goodSkuList" :key="ind">
				<template #default>
					<van-tag plain type="primary" v-for="(sku, iind) in item.goodSkus" :key="'sku_'+iind" :style="{'margin-right':'5px'}">{{sku}}</van-tag>
				</template>
				<template #right-icon>
					<van-icon name="edit"  class="color_red" :style="{'margin-left':'5px','margin-top':'5px'}" @click="addGoodSku(ind)"/>
					<van-icon name="cross" @click="delGoodSkuList(ind)" :style="{'margin-left':'5px','margin-top':'5px'}" class="color_red"/>
				</template>
			</van-cell>
		</van-cell-group>
		
		<div style="display:flex;">
			<van-button type="primary" block @click="saveGoodInfo()">保存</van-button>
		</div>
    </van-popup>

	<van-popup v-model="showGoodCategory" position="bottom" :style="{ 'max-height': '80%' }">
		<van-divider>
			商品分类
			<van-icon name="add" @click="addGoodCategory"  class="color_red" :style="{'margin-left':'10px'}"/>
		</van-divider>
		<van-cell-group>
			<van-field v-for="(item,i) in goodCategorys" :key="i" v-model.trim="item.c_name" :label="(i+1)+'、'" maxlength="6">
				<template #button>
					<van-icon name="arrow-up" @click="upGoodCategory(i,item)" v-show="i>0" />
					<van-icon name="arrow-down" @click="downGoodCategory(i,item)" v-show="i<goodCategorys.length-1" />
					<van-icon name="cross" @click="delGoodCategory(i,item.c_id)" class="color_red"/>
				</template>
			</van-field>
		</van-cell-group>
		
		<van-button type="primary" block :disabled="goodCategorys.length == 0" @click="saveGoodCategory()" >保存</van-button>
    </van-popup>

	<van-popup v-model="showGoodSku" position="bottom" :style="{ 'max-height': '80%' }">
		<van-cell-group>
			<van-field
				v-model.trim="newGoodSku.sku_name"
				required
				maxlength="10"
				label="名称："
				placeholder="请输入规格名称"
				required
				clearable
			>
				<template #button>
					<van-button size="small" type="info" @click="addNewGoodSku">+</van-button>
				</template>
			</van-field>
			<van-field v-for="(item,i) in newGoodSku.goodSkus" :key="i" v-model.trim="newGoodSku.goodSkus[i]" :label="(i+1)+'、'" maxlength="6">
				<template #button>
					<van-icon name="arrow-up" @click="upGoodSku(i,item)" v-show="i>0" />
					<van-icon name="arrow-down" @click="downGoodSku(i,item)" v-show="i<newGoodSku.goodSkus.length-1" />
					<van-icon name="cross" @click="delGoodSku(i)" class="color_red"/>
				</template>
			</van-field>
			<van-cell title="下单多选">
				<van-switch v-model="newGoodSku.sku_switch"/>
			</van-cell>
		</van-cell-group>
		
		<van-button type="primary" block :disabled="newGoodSku.goodSkus.length == 0" @click="saveGoodSku()" >确定</van-button>
    </van-popup>

	<van-popup v-model="showPicker" position="bottom" :style="{ 'max-height': '80%' }">
		<van-picker
			show-toolbar
			title="请选择"
			:columns="pickerColumns"
			:value-key="pickerValueKey"
			:default-index="pickerIndex['ind_'+pickerType]?pickerIndex['ind_'+pickerType]:0"
			@cancel="showPicker = false"
			@confirm="onPickerConfirm"
		/>
    </van-popup>

	<van-popup v-model="showJoinShoppingCart" position="bottom" :style="{ 'max-height': '80%' }">
		<van-cell-group>
			<van-cell
				title="商品名称："
				:value="goodInfo.g_name"
				title-class="van-cell-title">
			</van-cell>
			<van-cell
				title="下单数量："
				title-class="van-cell-title">
				<van-stepper v-model.number="shoppingGoodInfo.buys" :step="goodInfo.g_min_buy" integer input-width="50px" :max="goodInfo.g_day_limit>0?goodInfo.g_day_limit:goodInfo.g_stock"/>
				<template #right-icon>
					&nbsp;{{goodUnitObj[goodInfo.g_unit]}}
				</template>
			</van-cell>
			<van-field
				v-model.trim="shoppingGoodInfo.user"
				center
				clearable
				label="购买客户："
				:placeholder="shoppingGoodInfo.user_name?shoppingGoodInfo.user_name:'请输入客户账号'"
			>
				<template #button>
					<van-button size="small" type="info" @click="showPickers(4)">切换</van-button>
				</template>
			</van-field>

			<van-cell
				:title="sku.sku_name+'：'"
				title-class="van-cell-title"
				v-for="(sku,ind) in goodInfo.g_sku"
				:key="'sku_'+ind"
				>
				<template #default>
					<span 
						@click="chkGoodSku(ind, sind, sku.sku_switch)" 
						:class="{'van-sku-row__item': true}" 
						v-for="(skuo, sind) in sku.goodSkus" 
						:key="'isku_'+sind" 
						:style="{'margin':'0 0 0 5px'}"
						:ref="'ref_sku_'+ind+'_'+sind"
					>
						<div class="van-sku-row__item-name">{{skuo}}</div>
					</span>
				</template>
			</van-cell>

			<van-cell
				title="商品单价："
				:value="goodInfo.g_price"
				title-class="van-cell-title">
			</van-cell>
			<van-cell
				title="购买总价："
				:value="shoppingGoodInfo.buys*goodInfo.g_price"
				title-class="van-cell-title">
				<template #right-icon>
					&nbsp;元
				</template>
			</van-cell>

		</van-cell-group>

		<van-button type="primary" block @click="addShoppingCart()" >加入购物车</van-button>
    </van-popup>


	<van-popup v-model="showSettleShoppingCart" position="bottom" :style="{ 'max-height': '80%' }">
		<div  v-if="shoppingCart.cart.length>0">
			<van-collapse v-model="collapseActiveName" accordion>
				<van-collapse-item v-for="(user,ind) in shoppingCart.cart" :key="ind" :title="user.user_name" :name="'c_'+ind">
					<van-swipe-cell
					  v-for="(item,index) in user.goods"
					  :key="index">
						<van-card
						  :origin-price="item.g_price_origin>0?item.g_price_origin:null"
						  :title="item.g_name"
						  :thumb="attach_url+item.g_img"
						  class="van-card-small"
						>
							<template #price>
								<van-field v-model.number="item.g_price" type="number"  class="van-card-price">
									<template #button> &nbsp;元</template>
								</van-field>
							</template>
							<template #footer v-if="item.g_sku_str != ''">
								<van-field v-model.trim="item.g_sku_str" label="已选：" label-width="42px" :style="{'padding':'0 0 0 50px'}"/>
							</template>
							<template #num >
								<div class="van-card-num">
									<van-stepper v-model.number="item.buys" :step="item.g_min_buy" integer input-width="50px" :max="item.g_day_limit>0?item.g_day_limit:item.g_stock"/>
									&nbsp;{{goodUnitObj[item.g_unit]}}
								</div>
							</template>
						</van-card>
						<template #right>
							<van-button square text="移除" type="danger" class="van-swipe-cell-button"  @click="removeShoppingCartGood(ind, index)"/>
						</template>
					</van-swipe-cell>
					<van-cell-group>
						<van-field left-icon="location-o" label-width="50px" v-model.trim="user.address" label="地址：" placeholder="请输入详细地址" />
						<van-field left-icon="phone-o" label-width="50px" v-model.tel.trim="user.telphone" type="tel" label="电话：" placeholder="请输入联系电话" />
						<van-field left-icon="user-o" label-width="50px" v-model.trim="user.picker" label="姓名：" placeholder="请输入联系人姓名" />
						<van-field left-icon="free-postage" label-width="50px" v-model.number.trim="user.express" label="运费：" placeholder="请输入运费" v-if="user.address" />
						<van-field left-icon="flag-o" label-width="50px" v-model.trim="user.remark" label="备注：" maxlength="100" placeholder="请输入备注信息" />
					</van-cell-group>
					<van-submit-bar :price="user|sumOrderPrice" button-text="买单" @submit="submitShoppingCart(user,ind)" :style="{position:'static'}">
						<template #default>
							<van-button size="small" block @click="removeShoppingCart(ind)"  :style="{width:'50px'}">删除</van-button>
						</template>
					</van-submit-bar>
				</van-collapse-item>
			</van-collapse>
		</div>
    	<div class="empty" v-else>
			<span class="msg">还没有为客户下单</span>
		</div>
    </van-popup>

	<van-icon name="cart-circle" class="van-icon-cart-circle-float" @click="showSettleShoppingCart=true"/>
	<van-icon name="records" class="van-icon-cart-circle-float van-icon-cart-circle-float-4rem" @click="toShoppingOrder"/>

  </div>
</template>

<script type="text/ecmascript-6">
import { chkImgType,goodUnit } from "@/utils/common.js";
import { List, Card, Divider, Search, Stepper,SwipeCell, SubmitBar } from "vant";

export default {
	name: "storeGood",
	components: {
		"van-list": List,
		"van-card": Card,
		"van-divider":Divider,
		"van-search":Search,
		"van-stepper":Stepper,
		"van-swipe-cell":SwipeCell,
		"van-submit-bar":SubmitBar
	},
	data() {
		return {
			title: "商品管理",
			attach_url:this.Conf.serverPre,
			items: [],
			goodUnits:[],
			goodUnitObj:{},
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			filterParams:{
				u_id: localStorage.getItem("u_id"),
				token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
				c_id:0,
				offshelf:0,
				words:'',
				order:'',
				sort:''
			},
			imgList:[],
			imgNoteList:[],
			imgSizeLimit:500 * 1024,
			cur_s_id:-1,
			showGoodInfo:false,
			goodInfoInit:{g_min_buy:1,g_note:''},
			goodInfo:{},
			page:0,
			pageSize:0,
			total:0,
			loading: false,
			finished: false,
			refreshing: false,
			showGoodCategory:false,
			goodCategorys:[],
			goodCategoryObj:{},
			showPicker:false,
			pickerType:-1,
			pickerValueKey:'',
			pickerColumns:[],
			pickerIndex:{},
			searchFocus:false,
			categoryActive:0,
			showJoinShoppingCart:false,
			shoppingCart:[],
			shoppingGoodInfo:{},
			showSettleShoppingCart:false,
			collapseActiveName:'c_0',

			showGoodSku:false,
			goodSkuList:[],
			newGoodSku:{
				sku_name:'',
				sku_switch:false,
				goodSkus:['']
			},
			editGoodSkuInd:-1,
			chkGoodSkued:{}
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
	},
	computed:{
	},
	created() {
		this.getStateConfigs();
		this.cur_s_id = this.$route.params.s_id;
		if(!this.cur_s_id){
			this.goBack();
			return false;
		}
		this.filterParams['s_id'] = this.cur_s_id;
		this.loadData();
		this.getGoodCategory();
		this.goodUnitObj = goodUnit;
		let cols = [];
		for(var k in this.goodUnitObj){
			cols.push({key:k,name:this.goodUnitObj[k]});
		}
		this.goodUnits = cols;
		let storageShoppingCart = localStorage.getItem("shoppingCart")?JSON.parse(localStorage.getItem("shoppingCart")):{}
		if(!storageShoppingCart['store_'+this.cur_s_id]){
			storageShoppingCart['store_'+this.cur_s_id] = {user_ind:0,cart:[]}
		}
		this.shoppingCart = storageShoppingCart['store_'+this.cur_s_id];
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		goBack() {
			this.$router.push({
				path: "/StoreManage"
			});
		},
		loadData() {
			if (this.finished) {
				return false;
			}
			this.loading = true;
			setTimeout(() => {
				if (this.refreshing) {
					this.items = [];
					this.refreshing = false;
				}
				this.page = this.page+1;
				var params = this.filterParams;
				params.page = this.page;

				var url = this.Conf.serverUrl + "UserStore/storeGoods" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					this.loading = false;
					if(response.data.code == 40001){
						this.$toast.fail(response.data.msg);
					}else{
						if (response.data.page == 1) {
							this.pageSize = response.data.pageSize;
							this.total = response.data.total;
							this.items = response.data.goods;
						}else{
							this.items = this.items.concat(response.data.goods);
						}
						if(this.page*this.pageSize >= this.total){
							this.finished = true;
						}
					}
				})
				.catch(error => {});
			}, 1000);
		},
		onRefresh(cur) {
			this.finished = false;
			this.page = cur?(this.page-1):0;
			this.loadData();
		},
		goStoreGoodInfo(g_id) {
			this.showGoodInfo = true;
			this.goodInfo = this.goodInfoInit
			this.imgList = [];
			this.imgNoteList = [];
			this.goodSkuList = [];
			if(g_id){
				var params = {
					u_id: this.u_id,
					token: this.token,
					s_id:this.cur_s_id,
					g_id:g_id
				};
				var url = this.Conf.serverUrl + "UserStore/storeGood" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if(response.data.code == 40001){
						this.$toast.fail(response.data.msg);
						return false
					}
					this.goodInfo = response.data.good;
					this.imgList = [{url:this.attach_url+this.goodInfo.g_img}];
					if(this.goodInfo.g_note_img){
						this.imgNoteList = [{url:this.attach_url+this.goodInfo.g_note_img}];
					}
					if(this.goodInfo.g_sku){
						this.goodSkuList = JSON.parse(this.goodInfo.g_sku);
					}

				})
				.catch(error => {});
			}
		},
		beforeRead(file){
			return chkImgType(file);
		},
		onOversize(){
			this.$toast.fail("图片大小不能超过 500kb");
		},
		saveGoodInfo(){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定保存当前商品信息吗？",
			})
			.then(() => {
				if(this.imgList.length > 0 && this.imgList[0].content){
					this.goodInfo.g_img = this.imgList[0].content;
				}
				if(this.imgNoteList.length > 0 && this.imgNoteList[0].content){
					this.goodInfo.g_note_img = this.imgNoteList[0].content;
				}else{
					this.goodInfo.g_note_img = "";
				}
				
				var params = {
					u_id: this.u_id,
					token: this.token,
					s_id:this.cur_s_id,
					good:this.goodInfo
				};
				params.good.g_sku = (this.goodSkuList.length > 0)?this.goodSkuList:'';

				let that = this;
				var url = this.Conf.serverUrl + "UserStore/saveGoodInfo" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.showGoodInfo = false;
						that.onRefresh(true);
					}
				})
				.catch(error => {});
				
			})
			.catch((error) => {});
			return false;
		},
		offGoodInfo(g_id){
			this.$dialog
			.confirm({
				title: "下架提醒",
				message: "确定下架当前商品吗？",
			})
			.then(() => {
				var params = {
					u_id: this.u_id,
					token: this.token,
					s_id:this.cur_s_id,
					g_id:g_id
				};
				let that = this;
				var url = this.Conf.serverUrl + "UserStore/offGoodInfo" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.onRefresh();
					}
				})
				.catch(error => {});
				
			})
			.catch((error) => {});
			return false;
		},
		showGoodCategoryList(){
			this.showGoodCategory = true;
		},
		getGoodCategory(){
			var params = {
				u_id: this.u_id,
				token: this.token,
				s_id:this.cur_s_id
			};
			var url = this.Conf.serverUrl + "UserStore/storeGoodCategory" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.loading = false;
				if(response.data.code == 40001){
					this.$toast.fail(response.data.msg);
				}else{
					this.goodCategorys = response.data.category;
					this.goodCategoryObj = {};
					for(var i in this.goodCategorys){
						this.goodCategoryObj[this.goodCategorys[i]['c_id']] = this.goodCategorys[i]['c_name'];
					}

				}
			})
			.catch(error => {});
		},
		addGoodCategory(){
			this.goodCategorys.push({s_id:this.cur_s_id,c_sort:this.goodCategorys.length+1})
		},
		goodCategorySort () {
			this.goodCategorys = this.goodCategorys.sort((a, b) => a.c_sort - b.c_sort)
		},
		upGoodCategory(i,row){
			row.c_sort -= 1
			const prveRow = this.goodCategorys[i - 1]
			prveRow.c_sort += 1
			this.$set(this.goodCategorys, i, row)
			this.$set(this.goodCategorys, i - 1, prveRow)
			this.goodCategorySort()
		},
		downGoodCategory(i,row){
			row.c_sort += 1
			const nextRow = this.goodCategorys[i + 1]
			nextRow.c_sort -= 1
			this.$set(this.goodCategorys, i, row)
			this.$set(this.goodCategorys, i + 1, nextRow)
			this.goodCategorySort()
		},
		saveGoodCategory(){
			let categoryCnt = 0;
			for(var i in this.goodCategorys){
				if(this.goodCategorys[i].c_name == ""){
					this.$toast.fail("分类名称非空，请填写！");
					return false;
				}
				categoryCnt++;
			}
			if(categoryCnt==0){
				this.$toast.fail("请添加商品分类！");
			}
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定保存？",
			})
			.then(() => {
				var params = {
					u_id: this.u_id,
					token: this.token,
					s_id:this.cur_s_id,
					categorys:this.goodCategorys
				};
				let that = this;
				var url = this.Conf.serverUrl + "UserStore/saveGoodCategory" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.getGoodCategory();
						that.showGoodCategory = false;
					}
				})
				.catch(error => {});
				
			})
			.catch((error) => {});
			
		},
		delGoodCategory(i, c_id){
			if(!c_id){
				this.$delete(this.goodCategorys,i);
				if(this.goodCategorys.length > i){
					for(var ii=i; ii<this.goodCategorys.length; ii++){
						this.goodCategorys[ii].c_sort = this.goodCategorys[ii].c_sort-1;
					}
				}
				return false;
			}
			this.$dialog
			.confirm({
				title: "删除提醒",
				message: "删除后原商品分类将被移出，确定？",
			})
			.then(() => {
				var params = {
					u_id: this.u_id,
					token: this.token,
					s_id:this.cur_s_id,
					c_id:c_id
				};
				let that = this;
				var url = this.Conf.serverUrl + "UserStore/delGoodCategory" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.getGoodCategory();
					}
				})
				.catch(error => {});
				
			})
			.catch((error) => {});
			return false;
		
		},
		addGoodSku(i){
			this.editGoodSkuInd = i;
			this.newGoodSku = i==-1?{
				sku_name : "",
				sku_switch : false,
				goodSkus : ['']
			}:this.goodSkuList[i];
			this.showGoodSku = true;
		},
		addNewGoodSku(){
			this.newGoodSku.goodSkus.push('');
		},
		upGoodSku(i,row){
			let tmp = this.newGoodSku.goodSkus[i-1];
			this.newGoodSku.goodSkus[i-1] = row;
			this.newGoodSku.goodSkus[i] = tmp;
			this.$set(this.newGoodSku.goodSkus,i-1,this.newGoodSku.goodSkus[i-1])
			this.$set(this.newGoodSku.goodSkus,i,this.newGoodSku.goodSkus[i])

		},
		downGoodSku(i,row){
			let tmp = this.newGoodSku.goodSkus[i+1];
			this.newGoodSku.goodSkus[i+1] = row;
			this.newGoodSku.goodSkus[i] = tmp;
			this.$set(this.newGoodSku.goodSkus,i+1,this.newGoodSku.goodSkus[i+1])
			this.$set(this.newGoodSku.goodSkus,i,this.newGoodSku.goodSkus[i])
		},
		delGoodSku(i){
			this.$delete(this.newGoodSku.goodSkus, i);
		},
		delGoodSkuList(i){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定删除？",
			})
			.then(() => {
				this.$delete(this.goodSkuList, i);
			})
			.catch((error) => {});
		},
		saveGoodSku(){
			if(this.newGoodSku.sku_name == ""){
				this.$toast.fail("规格名称非空，请填写！");
				return false;
			}
			let newGoodSkuCnt = 0;
			for(var i in this.newGoodSku.goodSkus){
				if(this.newGoodSku.goodSkus[i] == ""){
					this.$toast.fail("规格分类名称非空，请填写！");
					return false;
				}
				newGoodSkuCnt++;
			}

			if(newGoodSkuCnt==0){
				this.$toast.fail("请添加商品分类！");
			}
			if(this.editGoodSkuInd == -1){
				this.goodSkuList.push(this.newGoodSku);
			}else{
				this.$set(this.goodSkuList,this.editGoodSkuInd,this.newGoodSku)
			}
			this.showGoodSku = false;
		},
		showPickers(t){
			this.pickerType = t;
			switch(t){
				case 1:
					this.pickerValueKey = 'c_name';
					this.pickerColumns = this.goodCategorys;
					break;
				case 2:
					this.pickerValueKey = 'name';
					this.pickerColumns = this.goodUnits;
					break;
				case 3:
					this.pickerValueKey = 'name';
					this.pickerColumns = [
						{order:'create',sort:'desc',name:'按创建时间降序'},
						{order:'create',sort:'asc',name:'按创建时间升序'},
						{order:'price',sort:'desc',name:'按价格降序'},
						{order:'price',sort:'asc',name:'按价格升序'},
						{order:'sales',sort:'desc',name:'按销售量降序'},
						{order:'sales',sort:'asc',name:'按销售量升序'},
						{order:'stock',sort:'desc',name:'按库存量降序'},
						{order:'stock',sort:'asc',name:'按库存量升序'}
					];
					break;
				case 4:
					this.pickerValueKey = 'user_name';
					this.pickerColumns = [{user:'',user_name:'新客户',goods:[]}];
					if(this.shoppingCart.cart.length > 0){
						this.pickerColumns = this.pickerColumns.concat(this.shoppingCart.cart);
					}
					break;
				default:
					break;
			}
			if(this.pickerIndex['ind_'+this.pickerType] == undefined || this.pickerIndex['ind_'+this.pickerType] >= this.pickerColumns.length){
				this.pickerIndex['ind_'+this.pickerType] = 0;
			}
			
			if(t == 4){
				this.shoppingGoodInfo.user = this.pickerColumns[this.pickerIndex['ind_'+this.pickerType]].user;
				this.shoppingGoodInfo.user_name = this.pickerColumns[this.pickerIndex['ind_'+this.pickerType]].user_name;
			}
			this.showPicker = true;
		},
		onPickerConfirm(value, index){
			switch(this.pickerType){
				case 1:
					this.goodInfo.c_id = value.c_id;
					break;
				case 2:
					this.goodInfo.g_unit = value.key;
					break;
				case 3:
					this.filterParams.order = value.order;
					this.filterParams.sort = value.sort;
					this.onRefresh()
					break;
				case 4:	
					this.shoppingGoodInfo.user = value.user;
					this.shoppingGoodInfo.user_name = value.user_name;
					break;
				default:
					break;
			}
			this.pickerIndex['ind_'+this.pickerType] = index;
			this.showPicker = false;
		},
		putShoppingCart(info){
			this.goodInfo = info;
			this.goodInfo.g_sku = (typeof info.g_sku == "object")?info.g_sku:((info.g_sku&&(typeof info.g_sku == 'string'))?JSON.parse(info.g_sku):[]);
			this.chkGoodSkued = {};
			this.shoppingGoodInfo = {
				g_id:info.g_id,
				s_id:info.s_id,
				g_name:info.g_name,
				g_img:info.g_img,
				g_price:info.g_price,
				g_price_origin:info.g_price_origin,
				g_day_limit:info.g_day_limit,
				g_stock:info.g_stock,
				g_min_buy:info.g_min_buy,
				g_unit:info.g_unit,
				buys:info.g_min_buy,
				user:this.shoppingGoodInfo.user?this.shoppingGoodInfo.user:'',
				user_name:this.shoppingGoodInfo.user_name?this.shoppingGoodInfo.user_name:'',
				g_sku:this.goodInfo.g_sku,
				g_sku_sel:{},
				g_sku_str:''
			}
			this.collapseActiveName = 'c_0';
			this.showJoinShoppingCart = true;
		},
		chkGoodSku(ind, sind, cswitch){
			let key = 'sku_'+ind+'_'+sind;
			if(this.chkGoodSkued[key]){
				//this.chkGoodSkued[key] = false;
				this.$refs['ref_'+key][0].className = 'van-sku-row__item';
				this.$delete(this.chkGoodSkued, key);
			}else{
				this.chkGoodSkued[key] = true;
				this.$refs['ref_'+key][0].className = 'van-sku-row__item van-sku-row__item--active';
				if(cswitch!='true'){
					for(var k in this.chkGoodSkued){
						if(k.indexOf('sku_'+ind+'_') > -1 && k!=key){
							//this.chkGoodSkued[k] = false;
							this.$refs['ref_'+k][0].className = 'van-sku-row__item';
							this.$delete(this.chkGoodSkued, k);
						}
					}
				}
			}
		},
		addShoppingCart(){
			let seledSkuStr = "";
			if(this.shoppingGoodInfo.g_sku.length > 0){
				let seledSku = false;
				let seledSkuVal = {};
				for(var k in this.chkGoodSkued){
					if(this.chkGoodSkued[k]){
						seledSku = true;
						var kk = k.split("_");
						if(seledSkuVal[kk[1]]){
							seledSkuVal[kk[1]].push(kk[2]);
						}else{
							seledSkuVal[kk[1]] = [kk[2]];
						}
					}
				}
				if(!seledSku){
					this.$toast.fail("请先选择商品规格！");
					return false;
				}

				this.shoppingGoodInfo.g_sku_sel = seledSkuVal;
				for(var k in seledSkuVal){
					seledSkuStr += this.shoppingGoodInfo.g_sku[k].sku_name;
					seledSkuStr += '（';
					let seledSkuVals = [];
					for(var ki in seledSkuVal[k]){
						seledSkuVals.push(this.shoppingGoodInfo.g_sku[k].goodSkus[seledSkuVal[ki]]);
					}
					seledSkuStr += seledSkuVals.join('，');
					seledSkuStr += '）';
				}
			}
			this.shoppingGoodInfo.g_sku_str = seledSkuStr;
			if(!this.pickerIndex['ind_4'] || this.pickerIndex['ind_4'] == 0){
				if(this.pickerIndex['ind_4']){
					this.pickerIndex['ind_4'] = this.shoppingCart.cart.length;
				}
				this.shoppingCart.user_ind++;
				this.shoppingGoodInfo.user_name = "客户 - " + (this.shoppingCart.user_ind);
				this.pickerIndex['ind_4'] = 1;
				this.shoppingCart.cart.push({user:'',user_name:"客户 - " + this.shoppingCart.user_ind,goods:[this.shoppingGoodInfo],express:0});
			}else{
				var userind = this.pickerIndex['ind_4']-1;
				if(this.shoppingGoodInfo.user != ""){
					for(var i in this.shoppingCart.cart){
						if(this.shoppingCart.cart[i].user == this.shoppingGoodInfo.user){
							userind = i;
							break;
						}
					}
				}
				if(userind == -1){
					this.shoppingCart.cart.push({user:this.shoppingGoodInfo.user,user_name:this.shoppingGoodInfo.user,goods:[this.shoppingGoodInfo],express:0});
					this.pickerIndex['ind_4'] = this.shoppingCart.cart.length;
				}else{
					var hadadd = -1;
					for(var i in this.shoppingCart.cart[userind].goods){
						if(this.shoppingGoodInfo.g_id == this.shoppingCart.cart[userind].goods[i].g_id){
							hadadd = i;
						}
					}
					if(hadadd == -1){
						this.shoppingCart.cart[userind].goods.push(this.shoppingGoodInfo);
					}else{
						var addgood = this.shoppingCart.cart[userind].goods[hadadd];
						var maxlimit = Math.max(this.shoppingGoodInfo.g_day_limit, this.shoppingGoodInfo.g_stock);
						if((addgood.buys + this.shoppingGoodInfo.buys) >= maxlimit){
							this.shoppingCart.cart[userind].goods[hadadd].buys = maxlimit;
						}else{
							this.shoppingCart.cart[userind].goods[hadadd].buys += this.shoppingGoodInfo.buys;
						}
					}
				}
			}
			this.showJoinShoppingCart = false;
			this.$toast.success("已加入购物单！");
		},
		removeShoppingCart(ind){
			this.$delete(this.shoppingCart.cart, ind);
			if(this.pickerIndex['ind_4'] && this.pickerIndex['ind_4']>=(ind+1)){
				this.pickerIndex['ind_4'] = this.pickerIndex['ind_4']==(ind+1)?0:(this.pickerIndex['ind_4']-1);
			}
			if(this.shoppingCart.cart.length == 0){
				this.shoppingCart.user_ind = 0;
				this.shoppingGoodInfo.user = "";
				this.shoppingGoodInfo.user_name = "";
				this.showSettleShoppingCart = false;
			}
		},
		removeShoppingCartGood(ind,index){
			this.$delete(this.shoppingCart.cart[ind].goods, index);
		},
		submitShoppingCart(cart,ind){
			if(cart.goods.length == 0){
				this.$toast.fail("请先添加购买商品！");
				return false;
			}
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定提交订单？",
			})
			.then(() => {
				let postData = {};
				for(var c in cart){
					if(!(c == 'goods' || c == 'remark' || c == 'express')){
						postData[c] = cart[c];
					}
				}
				postData['store'] = {};
				postData['store'][this.cur_s_id] = {'goods':cart.goods,'remark':cart.remark,'express':cart.express};
				let that = this;
				var url = this.Conf.serverUrl + "UserStore/saveOrder" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify({data:postData}))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.removeShoppingCart(ind);
						that.onRefresh(true);
					}
				})
				.catch(error => {});

			})
			.catch((error) => {});
		},
		toShoppingOrder(){
			this.$router.push({
				path: "/StoreOrder/"+this.cur_s_id
			});
		}
	},
	filters:{
		sumOrderPrice(u){
			let total = 0;
			for(var i in u.goods){
				total += u.goods[i].g_price*u.goods[i].buys
			}
			if(u.express){
				total += u.express;
			}
			return total*100;
		}
	},
	watch:{
		categoryActive(){
			this.filterParams.c_id = 0;
			this.filterParams.offshelf = 0;
			if(this.categoryActive>0 && this.categoryActive<=(this.goodCategorys.length+1)){
				if(this.categoryActive == this.goodCategorys.length+1){
					this.filterParams.offshelf = 1;
				}else{
					this.filterParams.c_id = this.goodCategorys[this.categoryActive-1].c_id;
				}
			}
			this.onRefresh()
		}
	},
	beforeDestroy: function () {
		let storageShoppingCart = localStorage.getItem("shoppingCart")?JSON.parse(localStorage.getItem("shoppingCart")):{}
		storageShoppingCart['store_'+this.cur_s_id] = this.shoppingCart;
		localStorage.setItem("shoppingCart", JSON.stringify(storageShoppingCart));
	}
};
</script>




// WEBPACK FOOTER //
// src/components/My/Store/StoreGoods.vue